import Page from 'modules/app/components/Page';
import s from '../ProductsByCategory/ProductsByCategory.module.scss';
import { useTypedSelector } from 'store/useTypedSelector';
import { useActions } from 'store/useActions';
import ShoppingCart from '../ShoppingCart';
import { useState, useRef, useEffect, useMemo } from 'react';
import useGetAllStores from 'sdk/hooks/shop/useGetAllStores';
import ShopTopMenu from 'components/shared/ShopTopMenu';
import StoreFilter from './StoreFilter';
import StoreCard from '../Stores/StoreCard';
import { useTranslation } from 'react-i18next';

const AllStores = () => {
    const { t } = useTranslation() as any;
    const { isOpenBasket } = useTypedSelector(state => state.postSlice);
    const { setIsOpenBasket } = useActions();
    const { data: stores } = useGetAllStores(); // No limit - get all
    const [showStoresDropdown, setShowStoresDropdown] = useState(false);
    const [selectedStore, setSelectedStore] = useState('All');

    const dropdownRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setShowStoresDropdown(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const filteredStores = useMemo(() => {
        if (!stores) return [];
        if (selectedStore === 'All') return stores;

        return stores.filter(store => {
            return store.store_name === selectedStore;
        });
    }, [stores, selectedStore]);

    return (
        <div style={{ overflow: 'auto' }}>
            <Page disableOverflow activeLink="/shop">
                <ShopTopMenu 
                    title={t('Stores')} 
                    onCartClick={setIsOpenBasket} 
                />
                <div className={s.container}>
                    <StoreFilter
                        selectedStore={selectedStore}
                        setSelectedStore={setSelectedStore}
                        showStoresDropdown={showStoresDropdown}
                        setShowStoresDropdown={setShowStoresDropdown}
                        stores={stores as Array<{ id: number; store_name: string }>}
                    />
                    <div className={s.grid}>
                        {filteredStores?.map(store => (
                            <StoreCard
                                key={store.id}
                                id={store.id}
                                avatar={store.avatar}
                                store_name={store.store_name}
                            />
                        ))}
                    </div>
                </div>
            </Page>
            <ShoppingCart open={isOpenBasket} setOpenShoppingCartMenu={setIsOpenBasket} />
        </div>
    );
};

export default AllStores;